import { Helmet } from "react-helmet-async";

interface SEOMetaProps {
  title: string;
  description: string;
  canonicalUrl?: string;
  ogImage?: string;
  ogType?: "website" | "article";
  publishedTime?: string;
  /**
   * Página privada/transacional (assinatura, pagamento, depoimento por token):
   * emite `robots: noindex, nofollow` e não publica canonical nem Open Graph,
   * para o link com token nunca ser indexado nem gerar preview com dado do cliente.
   */
  noindex?: boolean;
}

const BASE_URL = "https://eliveutonsouza.com";
const DEFAULT_IMAGE = `${BASE_URL}/og-image.png`;

const SEOMeta = ({
  title,
  description,
  canonicalUrl,
  ogImage = DEFAULT_IMAGE,
  ogType = "website",
  publishedTime,
  noindex = false,
}: SEOMetaProps) => {
  const fullTitle = title.includes("Eliveuton Dev") ? title : `${title} | Eliveuton Dev`;
  const canonical = canonicalUrl ? `${BASE_URL}${canonicalUrl}` : BASE_URL;

  if (noindex) {
    return (
      <Helmet>
        <title>{fullTitle}</title>
        <meta name="description" content={description} />
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
    );
  }

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <meta name="robots" content="index, follow" />
      <link rel="canonical" href={canonical} />

      <meta property="og:type" content={ogType} />
      <meta property="og:url" content={canonical} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage} />

      {ogType === "article" && publishedTime && (
        <meta property="article:published_time" content={publishedTime} />
      )}
    </Helmet>
  );
};

export default SEOMeta;
